import React, { useState } from 'react'

import { TFunction } from 'i18next'
import { v4 as uuidv4 } from 'uuid'

import { MfaAuthenticatorSetupForm } from './MfaAuthenticatorSetupForm'
import { MfaAuthenticatorVerifyForm } from './MfaAuthenticatorVerifyForm'

interface AccountMfaFormProps {
  activeView: 'mfa_step1' | 'mfa_step2'
  context: 'account' | 'settings'
  setActiveView: (view: 'mfa_step1' | 'mfa_step2') => void
  onClose: () => void
  onMfaSetupCompleted: () => Promise<void>
  t: TFunction<any>
  isLastMinute: boolean
  timeLeft: number | null
}

export const MfaAuthenticatorForm = ({
  activeView,
  context,
  t,
  isLastMinute = false,
  timeLeft = null,
  onClose,
  setActiveView,
  onMfaSetupCompleted,
}: AccountMfaFormProps) => {
  const [transactionId] = useState(uuidv4())

  return activeView === 'mfa_step1' ? (
    <MfaAuthenticatorSetupForm
      {...{
        transactionId,
        setActiveView,
        t,
        onClose,
        context,
        isLastMinute,
        timeLeft,
      }}
    />
  ) : (
    <MfaAuthenticatorVerifyForm
      {...{
        transactionId,
        setActiveView,
        t,
        onClose,
        context,
        onMfaSetupCompleted,
        isLastMinute,
        timeLeft,
      }}
    />
  )
}
